<template>
    <div class="justify-content-center mb-5">

        <div class="row justify-content-center">
            <div class="col-md-4 element-x-ray m-2" style="border: 1px solid rgba(255, 255, 255, .12);">
                <div style="">
                    <p class="fts-18 light-blue-01" style="font-weight: 900;"><span style="text-transform: uppercase;">{{ contract.portfolio.platform_contract_name }}</span></p>
                    <p class="fts-16 light-white-03">Votre solde sur ce contrat : <span style="font-weight: 900;" class="light-blue-01">{{ formatEuros(Math.round(contract.portfolio.amount,0)) }} €</span></p>
                    <p class="fts-16 light-white-03">Coût total de ce contrat : <span style="font-weight: 900;" class="light-blue-01">{{ formatEuros(Math.round(contract.portfolio.cost.total,0)) }} €</span></p>
                    <p class="fts-16 light-white-03">Coût total de ce contrat avec les frais de versements : <span style="font-weight: 900;" class="light-blue-01">{{ formatEuros(Math.round(contract.portfolio.cost.total_with_deposit,0)) }} €</span></p>
                    <div class="mb-3" style="border-bottom: 1px solid rgba(255, 255, 255, .12);"></div>
                    <p class="fts-16 m-emphasis mb-1">Dans le détail :</p>
                    <p class="fts-14 light-white-03 mb-1">Droits de garde : <span style="font-weight: 900;" class="light-blue-01">{{ formatEuros(Math.round(contract.portfolio.cost.platform_deposit,0)) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-1">Frais de transaction : <span style="font-weight: 900;" class="light-blue-01">{{ formatEuros(Math.round(contract.portfolio.cost.platform_transaction,0)) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-1">Frais de gestion sur les titres (fonds, ETFs) : <span style="font-weight: 900;" class="light-blue-01">{{ formatEuros(Math.round(contract.portfolio.cost.securities_management,0)) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-1">Frais d'entrée sur les titres (fonds) : <span style="font-weight: 900;" class="light-blue-01">{{ formatEuros(Math.round(contract.portfolio.cost.securities_entry,0)) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-3">Frais de versements (unique) : <span style="font-weight: 900;" class="light-blue-01">{{ formatEuros(Math.round(contract.portfolio.cost.platform_deposit,0)) }} €</span></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'contract',
            'token',
            'route',
        ],
        data() {
            return {
                customs:[],
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'info',
                headerTextVariant: 'light',
                bodyBgVariant: 'dark',
                bodyTextVariant: 'dark',
                footerBgVariant: 'info',
                footerTextVariant: 'dark'
            }
        },

        methods: {
        modalId(i) {
        return 'modal' + i;
        },
        formatEuros(number)
        {
            return this.$utils.numberWithSpaces(Number(number).toFixed(0));
        },
    }
}


</script>